<template>
    <div id="auth_root">
        <div v-if="!auth.auth_success" class="desktop">
            <div class="background" :style="{backgroundImage: 'url('+ config.background +')'}">
                <div class="backgroundOverlay">
                    <div class="form">
                        <br/>
                        <div class="text-center">
                            <img :src="config.logo" width="180" class="logo" alt=""/>
                        </div>
                        <br/>
                        <tabs name="auth" @change="(m)=>{mode = m}">
                            <tab name="login" title="Вход">
                                <inputi errorMsg='Неправильный формат'
                                        v-model="login" label="Email или телефон"
                                        placeholder="Введите ваш email или телефон"/>
                                <inputi label="Пароль"
                                        v-model="password" type="password"
                                        placeholder="Введите ваш пароль"/>
                                <btn label="Войти" icon="sign-in" type="primary" size="large" pull="right"
                                     :disabled="!allowSignIn" @press="signIn"/>
                                <br/>
                                <div class="text-left" v-if="config.password_reset">
                                    Забыли пароль? <a @click="mode='password_reset'">Восстановите его</a><br/>
                                </div>
                                <div v-if="config.signup">
                                    Нет учетной записи? <a @click="mode='register'">Зарегистрирутесь</a>.
                                </div>
                                <br/>
                                <br/>
                                <div v-if="config.socials" class="btn-group text-center">
                                    Так же вы можете войти с помощью социальных сетей: <br/>
                                    <btn label='Google' icon='google-plus' type='danger' size="large" @press="()=>{}"/>
                                    <btn label='Facebook' icon='facebook' type='primary' size="large" @press="()=>{}"/>
                                    <btn label='Вконтакте' icon='vk' type='info' size="large" @press="()=>{}"/>
                                    <btn label='Яндекс' icon='yahoo' type='danger' size="large" @press="()=>{}"/>
                                </div>
                            </tab>


                            <tab v-if="config.signup" name="register" title="Регистрация">
                                <inputi errorMsg='Неправильный формат'
                                        v-model="login"
                                        label="Email или телефон"
                                        placeholder="Введите ваш email или телефон"/>

                                <inputi
                                        errorMsg='Минимальная длинна пароля - 6 символов'
                                        v-model="password"
                                        label="Пароль"
                                        type="password" placeholder="Введите ваш пароль"/>
                                <inputi errorMsg='Пароли не совпадают'
                                        v-model="passwordRepeat"
                                        label="Пароль еще раз"
                                        type="password"
                                        placeholder="Повторите ваш пароль"/>
                                  <div class='text-center'> 
                                    <icheckbox v-model="agree" label="Я принимаю пользовательское соглашение"/>        
                                        
                             <btn label="Регистрация"
                                     icon="check-square" :disabled="!allowSignUp"
                                     type="primary" size="large"  @press="signUp"/></div>
                                <hr/>
                                <div>
                                    Уже есть учетная запись? <a @click="mode = 'login'">Войдите</a>.
                                    <br/>
                                    <p>После регистрации, вам на почту придет письмо с ссылкой для активации аккаунта, по
                                        которой необходимо перейти</p>
                                    <br/>
                                    <div v-if="config.socials" class="btn-group text-center">
                                        Так же вы можете зарегистрироватся с помощью социальных сетей: <br/>
                                        <btn label='Google' icon='google-plus' type='danger' size="large" @press="()=>{}"/>
                                        <btn label='Facebook' icon='facebook' type='primary' size="large" @press="()=>{}"/>
                                        <btn label='Вконтакте' icon='vk' type='info' size="large" @press="()=>{}"/>
                                        <btn label='Яндекс' icon='yahoo' type='danger' size="large" @press="()=>{}"/>
                                    </div>
                                </div>

                                <modal id='sms-confirm-modal'>
                                    <inputi label="Введите код из СМС" v-model="sms_code"/>
                                </modal>
                            </tab>


                            <tab v-if="config.password_reset" name="password-reset" title="Сброс пароля">
                                <inputi label="Email или телефон" 
                                        placeholder="Введите ваш email или телефон"
                                        errorMsg='Неправильный формат' v-model="login"/>
                                <inputi errorMsg='Минимальная длинна пароля - 6 символов' v-model="password"
                                        regex="regex.password" label="Новый пароль" type="password"
                                        placeholder="Введите ваш пароль"/>
                                <btn label="Сбросить пароль" :disabled="!allowResetPassword" icon="unlock-alt"
                                     type="primary" size="large" pull="right" @press="resetPassword"/>
                            </tab>


                            <tab v-if="config.fast_signin" name="fast-signin" title="Быстрый вход">
                                <inputi label="Email" errorMsg='Неправильный формат email'
                                        v-model="login" regex="regex.email" placeholder="Введите ваш email"/>
                                <btn :disabled="!allowFastSignIn"
                                     label="Отправить ссылку для быстрого входа" icon="rocket"
                                     type="primary" size="large" pull="right" @press="fastSignIn"/>
                            </tab>
                        </tabs>
                    </div>
                </div>
            </div>

            <!-- <imodal :shown="codeConfirmModalOpen" width="320">
                <div class="text-center">
                    <h4>Введите код из СМС</h4>
                </div>
                <inputi v-model="code"/>
                <div class="text-center">
                    <btn s="m" t="d" l="Отмена" @press="codeConfirmModalOpen = false"/>
                    <btn s="m" t="s" l="ОК" @press="codeConfirm"/>
                </div>
            </imodal>

            <imodal :shown="passwordResetCodeModalOpened" width="320">
                <div class="text-center">
                    <h4>Введите код из СМС</h4>
                </div>
                <inputi v-model="code"/>
                <div class="text-center">
                    <btn s="m" t="d" l="Отмена" @press="passwordResetCodeModalOpened = false"/>
                    <btn s="m" t="s" l="ОК" @press="confirmPasswordReset"/>
                </div>
            </imodal> -->
        </div>
        <slot v-if="auth.auth_success"/>
        
    </div>
</template>

<script>
    import methods from "../auth.methods";
    export default methods;
</script>

<style scoped>
    .desktop {
        height: 100%;
    }

    .desktop .background {

        background-size: cover;
        height: 100%;
        background-position: center;
    }

    .desktop .backgroundOverlay {
        background: rgba(104, 124, 255, 0);
        height: 100%;
        overflow: hidden;
    }

    .desktop .form {
        width: 500px;
        background: white;
        border-radius: 6px;
        overflow: hidden;
        margin: 20px auto 0;
        padding: 10px 20px;
    }

    .desktop .sider {
        height: 100%;
        box-sizing: border-box;
        padding: 20px;
        float: left;

    }

    .desktop .leftSide {
        width: 170px;
        background: #4b5f84;
        color: white;
    }

    .desktop .rightSide {
        width: 430px;
    }

    .desktop .title {
        font-weight: 600;
        font-size: 24px;
        padding: 0 0 0px;
    }

    .desktop .input {
        display: block;
        width: 100%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
        -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
        box-sizing: border-box;
    }

    .desktop .input:focus {
        border-color: #66afe9;
        outline: 0;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
    }

    .desktop .input.error {
        border-color: red;
    }

    .desktop .inputGroup {
        margin-bottom: 8px;
    }

    .desktop .errorMsg {
        color: red;
        font-size: 12px;
        float: right;
        padding: 4px;
    }

    .desktop .inputLabel {
        font-weight: 400;
        font-size: 14px;
        padding: 4px 0;
        display: inline-block;
    }

    .desktop .passwordReset {
        float: right;
    }

    .desktop .submitBtn {
        padding: 6px 12px;
        border-radius: 3px;
        background: linear-gradient(#0896fb, #1666ca);
        border: 1px solid #133d7d;
        color: white;
        display: inline-block;
        cursor: pointer;
    }

    .desktop .submitBtn.disabled {
        border-color: grey;
        background: linear-gradient(#cccccc, #616161);
        cursor: no-drop;

    }

    .desktop .submitBtn.disabled:hover {
        background: linear-gradient(#cccccc, #616161);

    }

    .desktop .submitBtn:hover {
        background: linear-gradient(#41b0ff, #297ae0);
    }

    .desktop .submitBtn:active {
        background: linear-gradient(#308ed2, #2878dc);
    }

    .desktop .socialBtns {
        text-align: center;
    }

    .desktop .socialBtn {
        padding: 6px 12px;
        border-radius: 4px;
        cursor: pointer;
        margin: 2px;
        border: 1px solid black;
        color: white;
        display: inline-block;
        width: 150px;
    }

    .desktop .redBtn {
        background: linear-gradient(#ffffff 0%, #f14545 4%, #b10101);
        border-color: #7d0505;
    }

    .desktop .blueBtn {
        background: linear-gradient(#ffffff 0%, #4580f1 4%, #013fb1);
        border-color: #05207d;
    }

    .desktop .lightblueBtn {
        background: linear-gradient(#ffffff 0%, #4f9ef3 4%, #015fb1);
        border-color: #05477d;
    }

    .desktop .logo {
        max-width: 100%;
    }

    @media (max-width: 600px) {
        .desktop .form {
            width: 96%;
            left: 0;
            top: 0;
            margin-left: 0;
            margin-top: 0;
            margin: 2%;
            height: auto;
        }

        .desktop .backgroundOverlay {

        }

        .desktop .logo {
        }

        .desktop .leftSide {
            width: 100%;
            height: auto;
        }

        .desktop .rightSide {
            width: 100%;
        }

        .desktop .submitBtn {
            width: 100%;
            box-sizing: border-box;
            font-size: 18px;
            text-align: center;
            padding: 12px 0;
        }

        .desktop .inputLabel {
            font-size: 16px;

        }

        .desktop .input {
            font-size: 18px;
            padding: 24px 12px;
        }

        .desktop .passwordReset {
            float: none;
            padding: 12px 12px;
            text-align: center;
            display: block;
            font-size: 18px;
        }

    }

    .desktop >>> .tab-content {
        padding-top: 15px;
    }
</style>

<style>
    html,body,.app,#auth_root{
        height:100%;
    }
</style>